import ColorIQContent from 'components/Header/BeautyPreferences/ColorIQContent/ColorIQContent';
import { withColorIQContentProps } from 'viewModel/header/beautyPreferences/colorIQContent/withColorIQContentProps';

const ConnectedColorIQContent = withColorIQContentProps(ColorIQContent);

export default ConnectedColorIQContent;
